import React, { Component, Fragment } from 'react';

import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';

import Card from '../../artzu-ui/src/Card';
import CheckBox from '../../artzu-ui/src/CheckBox';
import Modal from '../../artzu-ui/src/Modal';
import Button from '../../artzu-ui/src/Button';
import { m } from '../../utils';

import Footer from '../NewApply/Footer';

import coins from '../../images/Icons/Coins.svg';
import calendar from '../../images/Icons/Calendar.svg';
import profile from '../../images/Icons/Driver.svg';
// import Profile from '../../images/Icons/Profile.svg';

import ScrollLock from 'react-scrolllock';
import EncourageScroll from '../EncourageScroll';

const GQL_ROOT = `${process.env.REACT_APP_API_URL}/graphql`;

class ConnectWithVia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected:
        props.currentUser.existingUberPartner !== null &&
        (props.currentUser.existingUberPartner === false ? 'no' : 'yes'),
      checked: false,
      agreeModalOpen: false,
      learnModalOpen: false,
      earningModalOpen: false
    };
  }

  componentDidMount() {
    const { currentUser, incrementStep } = this.props;
    if (currentUser.accountName) {
      incrementStep();
    }
  }

  select = target => {
    const { selected } = this.state;
    if (target === 'yes') {
      if (selected !== 'yes') {
        this.setState({ selected: 'yes' });
      } else {
        this.setState({ selected: '' });
      }
    } else if (selected !== 'no') {
      this.setState({ selected: 'no' });
    } else {
      this.setState({ selected: '' });
    }
  };

  updateUser = () => {
    this.props.client.mutate({
      mutation: UPDATE_USER,
      variables: {
        userFields: {
          existingUberPartner: this.state.selected === 'yes',
        },
      },
    });
  };

  toggleAgreeModal = () => this.setState({ agreeModalOpen: !this.state.agreeModalOpen });

  toggleLearnModal = () => this.setState({ learnModalOpen: !this.state.learnModalOpen });

  toggleEarningModal = () => this.setState({ earningModalOpen: !this.state.earningModalOpen });

  toggleCheck = () => this.setState({ checked: !this.state.checked, selected: 'yes' });
  
  viaConsent = () => {
    const mutationString = gql`mutation ViaDeductionConsent($consentTime: DateTime!){
          viaDeductionConsent(consentTime: $consentTime) {
            consentReceived
          }
        }`;
    this.props.client.mutate({ mutation: mutationString, variables: { consentTime: m() } })
      .then((res) => {
        if (res.data.viaDeductionConsent.consentReceived === true) {
          this.toggleEarningModal();
          this.updateUser();
          this.props.incrementStep();
        }
      })
  }

  // onClick = () => {
  //   const { selected, checked } = this.state;
  //   const { uberTerms } = this.props;
  //   this.updateUser();
  //   this.props.incrementStep();
  //   if (selected === 'no') {
  //     this.updateUser();
  //     this.props.incrementStep();
  //   } else if (uberTerms) {
  //     if (checked) {
  //       this.updateUser();
  //       this.props.incrementStep();
  //     }
  //   } else {
  //     this.props.toggleUberTerms();
  //   }
  // };


  onClick = () => {
    const { selected, checked } = this.state;
    const { uberTerms } = this.props;
    if (uberTerms) {
      if (checked) {
        this.toggleEarningModal();
        // this.updateUser();
        // this.props.incrementStep();
        // window.location = this.props.uberUrl;
      } else {
        this.toggleAgreeModal();
      }
    } else {
      this.props.toggleUberTerms();
    }
  };


  render() {
    const { selected, checked, agreeModalOpen, learnModalOpen, earningModalOpen } = this.state;
    const { currentStep, currentUser, toggleUberTerms, uberTerms, title } = this.props;

    return (
      <Fragment>
        <Modal open={agreeModalOpen}>
          <div className="apply__uber--terms-modal">
            <div className="apply__uber--terms-modal-text">
              {' '}
              You need to agree to the terms before proceeding to the next step.{' '}
            </div>
            <div className="apply__uber--terms-modal-button">
              <Button label="Okay" onClick={() => this.toggleAgreeModal()} />
            </div>
          </div>
        </Modal>
        <Modal open={learnModalOpen}>
          <div className="apply__uber--terms-modal">
            <div className="apply__uber--terms-modal-text">
              {' '}
              In order to provide you a hassle free experience, Autzu receives your Uber earnings so that you do not
              need to pay a deposit or make any upfront payments.{' '}
            </div>
            <div className="apply__uber--terms-modal-button">
              <Button label="Okay" onClick={() => this.toggleLearnModal()} />
            </div>
          </div>
        </Modal>
        <Modal open={earningModalOpen}>
          <div className="apply__uber--terms-modal">
            <div className="apply__uber--terms-modal-text" style={{textAlign: "left", fontSize: "11px"}}>
              {' '}
              By clicking “Accept” with no further action, you agree that the fees you owe to Autzu 
              (including Booking Fees and additional fees as applicable) will be deducted from your Via Driver Partner earnings 
              and paid directly to Autzu on your behalf (the Earnings Deduction). 
              You may opt out of the Earnings Deduction by emailing info@autzu.com, 
              in which case you will be required to pre-pay your Booking Fees and any additional applicable fees by credit card.
              <br />
              See Section 6 of the <a href="/terms#earnings" target="_blank">Autzu Terms & Conditions</a> for more information.{' '}
            </div>
            <div className="apply__uber--terms-modal-button" style={{display: "flex", width: "100%", justifyContent: "space-evenly"}}>
              <Button label="Contact Us" onClick={() => {
                let media = window.matchMedia("(max-width: 767px)")
                if(media.matches) {
                  window.location.assign("tel:+18336928898")
                } else {
                  window.location.assign("/contact")
                }
              }} color="#414141" />
              <Button label="Accept" onClick={() => {
                this.viaConsent();
              }} />
            </div>
          </div>
        </Modal>
        <ScrollLock>
          <EncourageScroll className="apply__uber">
            <div className="apply__uber--container">
              <div className="apply__body--title"> {title}</div>
              {!uberTerms ? (
                <Fragment>
                  <div className="apply__body--message">
                    {' '}
                    Do you have an existing Via Driver account? Please select one of the following.
                  </div>
                  <div className="apply__uber--buttons">
                    <div className="apply__uber--card">
                      <Card width="100%" height="100%" selected={this.state.selected === 'yes'}>
                        <div className="apply__uber--card--container" onClick={() => this.select('yes')}>
                          <div className="apply__uber--card--title"> Yes, I have an active Via Driver account.</div>
                          <div className="apply__uber--card--text">
                            This means you have an active TLC License as well.
                          </div>{' '}
                        </div>
                      </Card>
                    </div>
                    <div className="apply__uber--card">
                      <Card width="100%" height="100%" selected={this.state.selected === 'no'}>
                        <div className="apply__uber--card--container" onClick={() => this.select('no')}>
                          <div className="apply__uber--card--title"> No, I do not have a Via Driver account.</div>
                          <div className="apply__uber--card--text">Don’t worry, we will create one for you.</div>{' '}
                        </div>
                      </Card>
                    </div>
                  </div>
                </Fragment>
              ) : (
                  <Fragment>
                    <div>By proceeding you allow Autzu to:</div>
                    <div className="apply__uber--condition-container">
                      <div className="apply__uber--condition">
                        <div className="apply__uber--condition-image">
                          <img alt="condition" src={profile} />
                        </div>
                        <div className="apply__uber--condition--text">
                          {' '}
                          Collect your driver information from Via (including performance, profile and earnings information).{' '}
                        </div>
                      </div>
                      <div className="apply__uber--condition">
                        <div className="apply__uber--condition-image">
                          <img alt="condition" src={calendar} />
                        </div>
                        <div className="apply__uber--condition--text">
                          {' '}
                          Allow Autzu to manage your Via driver account on your behalf, only to facilitate your bookings and user experience.{' '}
                        </div>
                      </div>
                    </div>
                    <div>All data collection and actions will be conducted to prevent fraudulent activity and with accordance to our <a href="/privacy">privacy policy</a> and <a href="/terms">terms & conditions</a>. Autzu will not collect or store any information that is not necessary for your bookings and day to day operations.</div>
                  </Fragment>
                )}
            </div>
          </EncourageScroll>
        </ScrollLock>
        <Footer
          currentStep={currentStep}
          currentUser={currentUser}
          back={uberTerms}
          onBackClick={() => {
            toggleUberTerms();
          }}
          active={selected}
          onNextClick={this.onClick}>
          {uberTerms ? (
            <CheckBox checkState={checked} label="I agree to the above." onClick={this.toggleCheck} />
          ) : null}
        </Footer>
      </Fragment>
    );
  }
}

const UPDATE_USER = gql`
  mutation updateUser($userFields: UserAttributes!) {
    updateUser(userFields: $userFields) {
      errors {
        message
      }
    }
  }
`;

export default withApollo(ConnectWithVia);



// WEBPACK FOOTER //
// ./src/components/NycApply/ConnectWithVia.js